/**
 * Smart API configuration that works with both LAN and Tailscale
 */

const getApiUrl = (): string => {
  // If explicitly set in environment, use that
  if (process.env.REACT_APP_API_URL) {
    console.log('🔍 getApiUrl: Using REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
    return process.env.REACT_APP_API_URL;
  }

  // Get current hostname
  const hostname = window.location.hostname;
  console.log('🔍 getApiUrl: hostname =', hostname, 'location =', window.location.href);
  
  // Determine which API URL to use based on where we're accessing from
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    // Local development
    console.log('🔍 getApiUrl: Using localhost');
    return 'http://localhost:3001/api';
  } else if (hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.')) {
    // LAN access - use the same IP but port 3001
    const result = `http://${hostname}:3001/api`;
    console.log('🔍 getApiUrl: Using LAN, result =', result);
    return result;
  } else if (hostname.startsWith('100.')) {
    // Tailscale network (100.64.0.0/10 range)
    const result = `http://${hostname}:3001/api`;
    console.log('🔍 getApiUrl: Using Tailscale, result =', result);
    return result;
  } else {
    // Fallback to relative URL (will use same host as frontend)
    console.log('🔍 getApiUrl: Using fallback /api');
    return '/api';
  }
};

// Export the function for dynamic use
export { getApiUrl };

// Dynamic API_URL that always gets fresh value
export const API_URL = getApiUrl();

// Log the configuration for debugging (v4) - Always fresh
console.log('🔧 API Configuration [DYNAMIC v4]:', {
  hostname: window.location.hostname,
  apiUrl: getApiUrl(), // Always call function fresh
  isTailscale: window.location.hostname.startsWith('100.'),
  isLAN: window.location.hostname.startsWith('192.168.') || window.location.hostname.startsWith('10.') || window.location.hostname.startsWith('172.'),
  isLocal: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
  timestamp: new Date().toLocaleTimeString()
});

// Helper to check if we're on Tailscale
export const isTailscale = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.startsWith('100.');
};

// Helper to check if we're on LAN
export const isLAN = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.startsWith('192.168.') || hostname.startsWith('10.') || hostname.startsWith('172.');
};

// Export network info for debugging
export const getNetworkInfo = () => {
  return {
    hostname: window.location.hostname,
    apiUrl: API_URL,
    isTailscale: isTailscale(),
    isLAN: isLAN(),
    isLocal: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
  };
};
